import React, { useEffect } from "react";
import styled from "styled-components";
import { certifications } from "../../Data/Constants.js";
import CertificationCard from "../Cards/CertificationCard";
import Aos from "aos";
import "aos/dist/aos.css";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 50px;
  position: relative;
  z-index: 1;
  align-items: center;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  font-size: 52px;
  text-align: center;
  font-weight: 600;
  margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 32px;
  }
`;

const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const CertificationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  width: 100%;
  margin-top: 30px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Certifications = () => {
  useEffect(() => {
    Aos.init();
  });

  return (
    <Container id="Certifications">
      <Wrapper>
        <Title data-aos="zoom-in" data-aos-once="true">
          Certifications & Licenses
        </Title>
        <Desc
          style={{
            marginBottom: "20px",
          }}
          data-aos="zoom-in"
          data-aos-once="true"
        >
          Professional certifications validating expertise in key technology
          areas and security practices.
        </Desc>

        <CertificationsGrid>
          {certifications.map((cert, index) => (
            <CertificationCard key={index} certification={cert} />
          ))}
        </CertificationsGrid>
      </Wrapper>
    </Container>
  );
};

export default Certifications;
